<template>
  <v-layout class="d-flex flex-wrap">
    <v-flex
      class="d-flex justify-center full_width mb-4"
    >
      <div
        ref="dashboard"
        class="dashboard"
      >
        <div v-show="isShowCanvas" >
          <canvas id="canvas"></canvas>
        </div>
      </div>
    </v-flex>
    <v-flex class="d-flex justify-center full_width mb-4">
      <div
        class="d-flex flex-nowrap justify-space-between align-center eraser px-1"
        :class="isDesktop ? 'mb-5' : ''"
      >
        <p class="eraser__note">{{ $t('step-three.eraser-note') }}</p>
        <v-btn
          class="eraser__size_7"
          :class="eraserWidth === 7 ? 'eraser__active' : ''"
          @click="onChangeEraserSize(7)"
        ></v-btn>
        <v-btn
          class="eraser__size_12"
          :class="eraserWidth === 12 ? 'eraser__active' : ''"
          @click="onChangeEraserSize(12)"
        ></v-btn>
        <v-btn
          class="eraser__size_15"
          :class="eraserWidth === 15 ? 'eraser__active' : ''"
          @click="onChangeEraserSize(15)"
        ></v-btn>
        <v-btn
          class="eraser__size_20"
          :class="eraserWidth === 20 ? 'eraser__active' : ''"
          @click="onChangeEraserSize(20)"
        ></v-btn>
        <v-btn
          class="eraser__cancel_button ml-1"
          @click="cancelEraser"
        >{{ $t('step-three.eraser-cancel-button') }}
        </v-btn>
      </div>
    </v-flex>
    <v-flex v-if="isMobile" class="d-flex justify-center text-center full_width">
      <p class="page_note">{{ $t('step-three.note') }}</p>
    </v-flex>
    <v-flex v-if="isMobile" class="d-flex justify-center full_width">
      <div class="d-flex flex-nowrap justify-space-between">
        <v-btn
          class="primary_button button_back mr-1"
          @click="onBackStep"
        >
          {{ $t('buttons.back') }}
        </v-btn>
        <v-btn
          class="primary_button ml-1"
          @click="onNextStep"
        >
          {{ $t('buttons.next') }}
        </v-btn>
      </div>
    </v-flex>

    <loading-modal ref="LoadingModal"/>
  </v-layout>
</template>

<script>
import {fabric} from "fabric";
import 'fabric-history';
import FileService from "@/services/FileService";
import LoadingModal from "@/components/home/loading-modal";
import {mapGetters} from "vuex";

const ZOOM = 4
const MARGIN_VALUE = 20

export default {
  name: "StepThreeComponent",
  mixins: [FileService],
  components: {
    'loading-modal': LoadingModal
  },
  props: {
    img: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      canvas: null,
      eraserWidth: 7,
      fabricImage: null,
      isConverted: false,
      isShowCanvas: true,
      imageScale: 0,
      zoom: ZOOM,
      marginValue: MARGIN_VALUE
    }
  },
  computed: {
    ...mapGetters('canvasHistory', [
      'canvasHistoryNextState',
    ]),
  },
  mounted() {
    window.scrollTo(0, 0)
    this.isShowCanvas = true
    this.isConverted = false
    this.canvasInit()
    this.fabricInit()
  },
  methods: {
    canvasMaxWidth() {
      const dashboardSettings = this.$refs.dashboard.getBoundingClientRect()
      return dashboardSettings.width
    },
    canvasMaxHeight() {
      const dashboardSettings = this.$refs.dashboard.getBoundingClientRect()
      return dashboardSettings.height
    },
    canvasInit() {
      this.canvas = new fabric.Canvas('canvas');
      this.canvas.setWidth(this.canvasMaxWidth());
      this.canvas.setHeight(this.canvasMaxHeight());
      this.canvas.freeDrawingBrush.width = this.eraserWidth;
      this.canvas.freeDrawingBrush.color = "white";
      this.canvas.backgroundColor = "white";
      this.canvas.isDrawingMode = true;
    },
    fabricInit() {
      let url = process.env.VUE_APP_CONVERT_IMAGE_SERVER_URL + `/returnImage.php?id=` + this.img
      fabric.loadSVGFromURL(url, (objects, options) => {
        let img = fabric.util.groupSVGElements(objects, options);
        if (img.height < img.width) {
          img.scaleToWidth(this.canvasMaxWidth())
        } else {
          img.scaleToHeight(this.canvasMaxHeight())
        }

        if (img.height < img.width) {
          let width = img.height * img.scaleY < this.canvasMaxHeight() ? this.canvasMaxWidth() : this.canvasMaxHeight()
          img.scaleToWidth(width)
        }

        img.top = Math.round(this.getImageTop(img))
        img.left = Math.round(this.getImageLeft(img))
        this.fabricImage = img
        this.canvas.add(img);
        this.initCanvasHistory()
        this.$refs.LoadingModal.isModalOpen = false
      })
    },
    initCanvasHistory() {
      if (this.canvasHistoryNextState) {
        this.canvas.clearHistory()
        this.canvas._loadHistory(this.canvasHistoryNextState, 'history:undo')
        this.canvas.historyUndo.splice(0, 1)
      }
    },
    getImageLeft(img) {
      return (this.canvasMaxWidth() - img.width * img.scaleX) / 2;
    },
    getImageTop(img) {
      return (this.canvasMaxHeight() - img.height * img.scaleY) / 2;
    },
    onChangeEraserSize(size) {
      this.eraserWidth = size
      this.canvas.freeDrawingBrush.width = size;
      this.canvas.requestRenderAll();
    },
    cancelEraser() {
      if (this.canvas.historyUndo.length > 1) {
        this.canvas.undo()
      }
    },
    onBackStep() {
      this.$emit('onBackStep')
    },
    async onNextStep() {
      this.$refs.LoadingModal.isModalOpen = true
      this.saveCanvasHistory()
      this.resizeCanvasBeforeUploadImage()
      await this.uploadImage()

    },
    saveCanvasHistory() {
      this.$store.dispatch('canvasHistory/setCanvasHistoryNextState', JSON.parse(this.canvas.historyNextState))
    },
    resizeCanvasBeforeUploadImage() {
      this.canvas.setZoom(this.zoom)
      this.canvas.setWidth(this.canvas.width * this.zoom);
      this.canvas.setHeight(this.canvas.height * this.zoom);
      this.canvas.requestRenderAll();
      this.isShowCanvas = false
    },
    uploadImage() {
      const payload = new FormData
      payload.append('file', this.dataURLtoFile(this.canvas.toDataURL({
        format: 'png',
        left: this.fabricImage.left * this.zoom - this.marginValue / 2,
        top: this.fabricImage.top * this.zoom - this.marginValue / 2,
        width: (this.fabricImage.width * this.fabricImage.scaleX) * this.zoom + this.marginValue,
        height: this.fabricImage.height * this.fabricImage.scaleY * this.zoom + this.marginValue
      }), "cleanedImage.jpg"));

      this.uploadFileForConvert(payload)
        .then(async (response) => {
          this.imageId = response.data
          await this.getSvgFile()
        })
        .catch((err) => {
          console.log('error', err)
          this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
        })
    },
    dataURLtoFile(dataUrl, filename) {
      const arr = dataUrl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const binaryString = atob(arr[1])
      let counter = binaryString.length
      let u8arr = new Uint8Array(counter)

      while (counter--) {
        u8arr[counter] = binaryString.charCodeAt(counter);
      }

      return new File([u8arr], filename, {type: mime});
    },
    getSvgFile() {
      const counter = 0
      this.recursiveConversionRequest(counter)
    },
    recursiveConversionRequest(counter) {
      counter++
      if (counter > 200) {
        clearTimeout(this.timer)
        return false;
      }

      this.checkConvertToSvg()
      if (!this.isConverted) {
        this.timer = setTimeout(() => {
          this.recursiveConversionRequest(counter)
        }, 500)
      } else {
        clearTimeout(this.timer)
        this.$refs.LoadingModal.isModalOpen = false
        this.$emit('setFabricImageId', this.imageId)
        this.$emit('onNextStep')
      }
    },
    checkConvertToSvg() {
      const params = {
        'unique_id': this.imageId
      }
      this.checkToCovertFile(params)
        .then((response) => {
          this.isConverted = !!response.data
        })
        .catch((err) => {
          console.log('error', err)
          this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
        })
    }
  }
};
</script>
